// extracted by mini-css-extract-plugin
export default {"header":"header_header__5lohc","header__logo":"header_header__logo__lmXV1"};